import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["option", "criteria", "submit"]
  static values = { emoji: String }

  add(event) {
    event.preventDefault()
    if (!this.hasEmojiValue) return

    this.logEmoji(this.emojiValue).then(() => {
      this.element.closest("dialog")?.close()
    })
  }

  select(event) {
    const button = event.currentTarget
    this.selectedEmoji = button.dataset.emoji
    this.selectedValue = Number(button.dataset.ratingValue)

    this.fillTo(this.selectedValue)
    this.showCriteria(button.dataset.criteria)

    this.submitTarget.disabled = false
  }

  preview(event) {
    const button = event.currentTarget
    this.fillTo(Number(button.dataset.ratingValue))
    this.showCriteria(button.dataset.criteria)
  }

  resetPreview() {
    const selected = this.optionTargets.find((option) => Number(option.dataset.ratingValue) === this.selectedValue)
    this.fillTo(this.selectedValue || 0)
    this.showCriteria(selected?.dataset.criteria)
  }

  fillTo(value) {
    this.optionTargets.forEach((option) => {
      const filled = Number(option.dataset.ratingValue) <= value
      option.classList.toggle("opacity-100", filled)
      option.classList.toggle("opacity-40", !filled)
    })
  }

  showCriteria(criteriaText) {
    this.criteriaTarget.textContent = criteriaText || ""
  }

  submit(event) {
    event.preventDefault()
    if (!this.selectedEmoji) return

    this.logEmoji(this.selectedEmoji).then(() => {
      this.element.closest("dialog")?.close()
    })
  }

  logEmoji(emoji) {
    const token = document.querySelector('meta[name="csrf-token"]')?.content ?? ""

    return fetch("/emoji_activities", {
      method: "POST",
      headers: {
        "X-CSRF-Token": token,
        "Accept": "text/vnd.turbo-stream.html",
      },
      body: new URLSearchParams({ emoji }),
    })
      .then((response) => response.text())
      .then((html) => Turbo.renderStreamMessage(html))
  }
}
